import type { Dispatch, AnyAction } from 'redux';

import type UserOptionVM from 'ab-viewModels/user/option.viewModel';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import API from 'af-constants/routes/api';

export function fetchMissingUsers() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<UserOptionVM[]>(API.V1.USERS.MISSING_MEMBERS_LIST);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
